import LegalLayout, { LegalSection, LegalList } from "../../components/chalk/LegalLayout";

export default function ChildrenPrivacy() {
  return (
    <LegalLayout title="Children's Privacy" eyebrow="Legal" lastUpdated="February 2026" testId="page-children-privacy">
      <LegalSection heading="No independent child accounts">
        <p>
          Children do not create independent Chalk OS accounts in V1. Athlete profiles are created by
          coaches, league admins, or guardians for the purpose of team coordination.
        </p>
      </LegalSection>

      <LegalSection heading="What an athlete profile contains">
        <p>An athlete profile may include:</p>
        <LegalList items={[
          "Name and team",
          "Jersey number and position",
          "Schedule and RSVP status",
          "Guardian links",
          "Volunteer duties",
          "Optional notes entered by authorized adults",
        ]} />
      </LegalSection>

      <LegalSection heading="Restricted information">
        <p>
          Medical notes and emergency contact data are restricted and are never visible to other
          parents. Only the coach and league admin for the athlete's team can view these fields, and
          only to fulfil their team-management role.
        </p>
      </LegalSection>

      <LegalSection heading="Guardian rights">
        <p>
          Guardians can request review, correction, deletion, or limitation of a child's data by
          emailing <a href="mailto:support@getchalkos.com" style={{ color: "#2E7D52" }}>support@getchalkos.com</a>{" "}
          from the email on the account. Include the athlete's name, team, and the change you would
          like made. We may need to verify identity before processing the request.
        </p>
      </LegalSection>

      <LegalSection heading="Data sharing">
        <p>
          Chalk OS does not sell athlete data, does not use athlete data for targeted advertising, and
          does not share athlete data with third parties beyond what is necessary to operate the
          platform (for example, hosting, transactional email delivery, billing).
        </p>
      </LegalSection>

      <LegalSection heading="Questions">
        <p>
          Email <a href="mailto:support@getchalkos.com" style={{ color: "#2E7D52" }}>support@getchalkos.com</a>{" "}
          for any question about how Chalk OS handles a child's information.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
